import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { StarIcon } from '@cp/ds/src/icons';
import { Box } from '@cp/ds/src/components/box';
import { Link } from '@cp/ds/src/components/link';
import { styled } from '@youhelp-ru/ui';
import TBank from 'src/assets/shapes/tBank.svg';

const Root = styled(Stack)(({ theme }) => ({
  paddingTop: '12px',
  paddingBottom: '20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '12px',
  backgroundColor: theme.palette['gray ultra light'],
  [theme.breakpoints.up('md')]: {
    paddingTop: '36px',
    paddingBottom: '16px',
    gap: '10px',
  },
}));

const StyledText = styled(Typography)(({ theme }) => ({
  typography: 'h1',
  color: theme.palette['gray dark'],
  [theme.breakpoints.up('lg')]: {
    typography: 'h0',
  },
}));

export const TBankRating = () => {
  return (
    <Link
      external
      href="https://www.tbank.ru/reviews/company/yukhelp-youhelp/151239/?channel=search"
      sx={{
        display: 'contents',
      }}
      underline={false}
    >
      <Root direction={{ xs: 'column', md: 'row' }}>
        <Stack direction="row" sx={{ justifyContent: 'center', alignItems: 'center', gap: { xs: 1, md: 2 } }}>
          <StyledText component="span" sx={{ typography: { xs: 'h1', lg: 'h0' } }}>
            4.91
          </StyledText>
          <StarIcon sx={{ fontSize: { xs: '2rem', lg: '3.5rem' }, color: '#FFDD2D' }} />
        </Stack>
        <Stack alignItems="center" direction={{ xs: 'column', md: 'row' }} gap={{ xs: 1.5, sm: 2.25 }} justifyContent="center">
          <StyledText component="span" sx={{ typography: { xs: 'button', lg: 'h1' } }}>
            на основании 62 отзывов
          </StyledText>
          <Box sx={{ width: { xs: 120, lg: 163 } }}>
            <TBank />
          </Box>
        </Stack>
      </Root>
    </Link>
  );
};
